import React, { useMemo, useRef, useState } from "react";
import { TableContainer, Paper, Box, IconButton, Typography } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import sv from "date-fns/locale/sv";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Verification } from "@/types/verification";
import Table from "./table";
import Filters from "./filters";
import { i18n } from "@/utils/i18n";
import { useNavigate, useParams } from "react-router-dom";
import { Params } from "@/types/utils";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FileDescriptor } from "../common/modals/file-viewer/context";

interface Props {
    verifications: Verification[];
}

const Form: React.FC<Props> = ({ verifications }) => {
    const navigate = useNavigate();
    const { oid, sid, rid } = useParams<Params>();
    const attachmentsCache = useRef<Map<number, FileDescriptor>>(new Map());
    const [dateRange, setDateRange] = useState<{ startDate?: Date; endDate?: Date }>({});

    const filteredVerifications = useMemo(() => {
        return verifications
            .filter(v => {
                const transactionDate = new Date(v.transaction.date);
                const { startDate, endDate } = dateRange;
                return (
                    (!startDate || transactionDate >= startDate) &&
                    (!endDate || transactionDate <= endDate)
                );
            })
            .sort(
                (a, b) =>
                    new Date(a.transaction.date).getTime() - new Date(b.transaction.date).getTime(),
            );
    }, [dateRange, verifications]);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={sv}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                <IconButton
                    aria-label="Go back"
                    onClick={() =>
                        navigate(`/organizations/${oid}/submissions/${sid}/reports/${rid}`)
                    }
                    sx={{ color: "text.primary" }}
                >
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5" fontWeight="bold">
                    {i18n.t("verificationList")}
                </Typography>
            </Box>
            <TableContainer component={Paper} sx={{ p: 2 }}>
                <Filters
                    dateRange={dateRange}
                    setDateRange={setDateRange}
                    verifications={filteredVerifications}
                />
                <Table attachmentsCache={attachmentsCache} verifications={filteredVerifications} />
            </TableContainer>
        </LocalizationProvider>
    );
};

export default Form;
